import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ResetPasswordPayload, ResetPasswordResponse } from "./reset-password.entity";
import { resetPassword } from "./reset-password.api";

interface ResetPasswordState {
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string | null;
}

const initialState: ResetPasswordState = {
  loading: false,
  error: null,
  success: false,
  message: null,
};

export const updatePassword = createAsyncThunk<
  ResetPasswordResponse,
  ResetPasswordPayload
>("resetPassword/updatePassword", async (payload) => {
  return await resetPassword(payload);
});

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    clearResetPasswordState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.message = null;
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
      })
      .addCase(updatePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to reset password";
        state.success = false;
      });
  },
});

export const { clearResetPasswordState } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;

